module.exports = __webpack_public_path__ + "img/ajiltans_logo.3119b20c.svg";